import { render, staticRenderFns } from "./SalesforceAppDetails.vue?vue&type=template&id=56e53922&"
import script from "./SalesforceAppDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./SalesforceAppDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports